import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminChangePassword() {
  const navigate = useNavigate();
  const { setMustChangePassword } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    if (next.length < 6) {
      toast.error("Mot de passe trop court (6 caractères minimum)");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/admin/change-password", { current_password: current, new_password: next });
      setMustChangePassword(false);
      toast.success("Mot de passe mis à jour");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF7F0] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-black/5 p-8 space-y-5" data-testid="change-pwd-form">
        <h2 className="font-display text-2xl text-[#B8860B]">Définir un nouveau mot de passe</h2>
        <p className="text-xs text-[#6B6B6B]">Première connexion : veuillez changer le mot de passe par défaut.</p>
        <div>
          <label className="label-tiny block mb-1">Mot de passe actuel</label>
          <input className="input-gold" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="pwd-current" />
        </div>
        <div>
          <label className="label-tiny block mb-1">Nouveau mot de passe</label>
          <input className="input-gold" type="password" value={next} onChange={(e) => setNext(e.target.value)} required data-testid="pwd-new" />
        </div>
        <div>
          <label className="label-tiny block mb-1">Confirmation</label>
          <input className="input-gold" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="pwd-confirm" />
        </div>
        <button type="submit" className="btn-primary w-full" disabled={submitting} data-testid="pwd-submit">
          {submitting ? "Enregistrement..." : "Enregistrer"}
        </button>
      </form>
    </div>
  );
}
